import React, {Component, useState} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {prosLog, STR_YES, UI_LISTED_ELEMENTS_LIMIT} from "../prodect/ProsConnect";
import {formatUtcDate, openUrl} from "../prodect/ProsCommonUi";
import {
    ATTR_TEXT,
    ATTR_UPDATED_MS_I,
    ATTR_FILE_NAME,
    STR_NO_VALUE,
    getProjectSharedReports
} from "../prodect/ProsConnect";
import {setHelpContext} from "../prodect/HelpManager";
import {prosPopupClose, prosPopupOpen} from "../prodect/ProsPopup";
import LoadingAnimation from "../components/LoadingAnimation";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Pagination from "../components/Pagination";

export default class SharedReports extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            obsHistoryList: undefined,
            deletePopup: false,
            itemToRemove: undefined,
            activeProject: this.props.activeProject,
        };
    };

    async refreshUi() {
        let project = prosConnect.getActiveProject();
        await prosConnect.getActiveProject().awaitRefreshProjectObjectsFromAws();
        let uiList;
        if (project) {
            uiList = getProjectSharedReports(project);
        }
        this.setState({
            obsHistoryList: uiList,
            isLoading: false,
        });
    }

    async componentDidMount() {
        let project = prosConnect.getActiveProject();
        if (project) {
            this.refreshUi();
        } else {
            this.setState({isLoading: false})
        }
        setHelpContext('sentReports')
    }

    componentWillUnmount() {
        prosLog("SharedReports::componentWillUnmount() --");
    }

    componentDidUpdate() {
        if (this.state.activeProject !== this.props.activeProject) {
            this.setState({
                activeProject: this.props.activeProject,
            });
            this.refreshUi();
        }
    }


    showDeletePopup(history) {
        this.setState({
            itemToRemove: history
        }, () => this.openPopupDelete());
    }

    openPopupDelete() {
        prosPopupOpen(this,
            'Poista historia',
            <>
                <section>
                    <p>Oletko varma että haluat poistaa raportin "{this.state.itemToRemove.ui_reportName}" ? </p>
                    <p><strong className={"color-2nd"}>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</strong></p>
                </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <CancelButton
                            action={()=> prosPopupClose()}
                        />
                        <ConfirmButton
                            btnType={"fatal"}
                            action={()=> this.deleteHistory()}
                        />
                    </div>
                </footer>
            </>
        )
    }

    openWebLink(historyObj) {
        if ('report_req_obj' in historyObj && historyObj.report_req_obj.generate_pdf === STR_YES) {
            let url = prosConnect.getItemSavedPdfPath(historyObj);
            openUrl(url);
        } else {
            let url = prosConnect.getItemHtmlPath(historyObj);
            openUrl(url);
        }
    }

    async deleteHistory() {
        prosPopupClose()
        await prosConnect.getActiveProject().awaitRemoveItem(this.state.itemToRemove);
        this.refreshUi()
    }

    goBack() {
        this.props.history.goBack()
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        if (this.state.obsHistoryList) {
            return this.state.obsHistoryList.length < 1 ? <p>Osaprojektissa ei ole lähetettyjä raportteja.</p>
                : <HistoryList
                    historyList={this.state.obsHistoryList}
                    openWebLink={history => this.openWebLink(history)}
                    showDeletePopup={history => this.showDeletePopup(history)}
                />
        }
        return <h2>Lataa projekti</h2>
    }
}

function HistoryList(props) {
    const [page, setPage] = useState(0)
    function renderMessageText(history) {
        let preViewHtml = "_preview.html"
        if (history[ATTR_FILE_NAME] && history[ATTR_FILE_NAME].includes(preViewHtml)) {
            return "Aktiivinen raportti"
        }
        if (history[ATTR_TEXT] === STR_NO_VALUE) {
            return "Viesti: -"
        } else {
            return "Viesti: " + history[ATTR_TEXT]
        }
    }
    const chunkSize = UI_LISTED_ELEMENTS_LIMIT * 2//20 items per page
    const allPagesAmount = props.historyList.length
    const displayList = props.historyList.slice(page, page + chunkSize).map((history, i) => {
        let text = renderMessageText(history)
        return <div key={i} className={"inpage-box"}>
            <header>
                <h4 onClick={() => {
                    props.openWebLink(history)
                }}
                    className={"display-flex valign-center flex-grow"}
                >
                    <i className={"ui-icon ui-icon-open-new"}/>
                    <span className={"lnk"}>{ history.ui_reportType } : {history.ui_reportName}</span>
                </h4>
                <BasicButton
                    icon={"times"}
                    action={()=>{
                        props.showDeletePopup(history)
                    }}
                    btnType={"prompt"}
                />
            </header>
            <section className={"text-sm"}>
                <p className={"margin-0"}>{text}<br/>
                    {formatUtcDate(history[ATTR_UPDATED_MS_I])} - {history.ui_sentTo}
                </p>
            </section>
        </div>
    })
    return <>
        <div className={"grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd"}>
        {displayList}
        </div>
        {allPagesAmount > chunkSize ? <Pagination
            btnClass={"3rd"}
            chunk={chunkSize}
            currentPage={page}
            allItemsInt={allPagesAmount}
            callback={val=> setPage(val)}
            showPages
            disableLoop
            className={"btn-set margin-top"}
        /> : null}
    </>
}